import axios from "axios";
import config from "../../settings/config";
import { handleError } from "../../network/servicErrorHandling";

async function apiService(url, methodType, body, catchReturn) {
  axios.defaults.headers.common["Authorization"] = localStorage.getItem(
    `${window.location.hostname}_token`
  );
  return Promise.resolve().then((v) =>
    axios({
      method: methodType,
      url: url.includes("http") ? url : `${config.baseUrl}${url}`,
      data: body,
    })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (catchReturn) {
          return err;
        } else {
          handleError(err);
        }
      })
  );
}

export { apiService };
